export default "__VITE_ASSET__CBUVfMwt__";